/**
 * A quick temporary notification.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { quickMessageFadeOutDuration } from '../../theme/uiConfig';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = theme => ({
	quickMessage: {
		backgroundColor: theme.palette.colors.zeta,
		borderRadius: '9px',
		height: '40px',
		padding: '10px 10px 11px 10px',
		color: theme.palette.colors.white,
		marginBottom: '1rem',
		opacity: 0.31,
		transition: `opacity ${quickMessageFadeOutDuration}ms ease-in-out`,
		fontFamily: theme.typography.fontFamily,
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '18px',
		zIndex: 1001,
		position: 'relative'
	},
	quickMessageFading: {
		opacity: 0
	}
});

@withStyles(styles)
class QuickMessage extends Component {

	render() {
		const { classes, fading } = this.props;
		return (<div className={classNames(classes.quickMessage, fading && classes.quickMessageFading)}>
			{this.props.message}
		</div>);
	}

}

QuickMessage.propTypes = {
	classes: PropTypes.object,
	message: PropTypes.string,
	fading: PropTypes.bool
};

export default QuickMessage;


// WEBPACK FOOTER //
// ./src/components/QuickMessages/QuickMessage.js